import FramedScreenshot from './FramedScreenshot';

export default FramedScreenshot;
